<template>
  <table class="product-table" v-if="filteredList && filteredList.length > 0">
    <thead>
    <tr>
      <th class="product-table__headers" v-for="header in filteredHeaders" :key="header.dataName">
        <div @click="sortColumn(header)">
          {{ header.translation }}
          <div :class="[{ 'product-table__headers--arrow-blue': header.isActive, 'product-table__headers--arrow-down': header.Descending }, 'product-table__headers--arrow-up']"></div>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in filteredList" :key="item.itemNo" class="product-table__td-row">
      <td class="product-table__id" :label="headers.number.translation">{{ item.itemNo }}</td>
      <td class="product-table__name" :label="headers.name.translation">
        <a class="link" :href="item.url" @click="trackClick(item)">{{ item.displayName }}</a>
      </td>
      <td class="product-table__family" :label="headers.family.translation">{{ item.productFamiliesAsString }}</td>
      <td class="product-table__seriestart" :label="headers.serialstart.translation">{{ item.serialNumberStart }}</td>
      <td class="product-table__seriestop" :label="headers.serialstop.translation">{{ item.serialNumberStop }}</td>
      <td class="product-table__language" :label="headers.language.translation">{{ item.language }}</td>
      <td class="product-table__category" :label="headers.category.translation">{{ item.category }}</td>
      <td v-if="productStore.selectedProduct === 'E-Services'" class="product-table__programversion" :label="headers.programversion.translation">{{ item.programVersion }}</td>
    </tr>
    </tbody>
  </table>
  <h2 v-else class="no-search-result">{{ productStore.translations?.noResult }}</h2>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useProductStore } from '../store/store';

const productStore = useProductStore();

const filteredList = ref([]);

const updateFilteredList = () => {
  let tempList = productStore.searchResult.data || [];
  if (productStore.search) {
    tempList = tempList.filter(item =>
        item.serialNumberStart <= parseInt(productStore.search) &&
        item.serialNumberStop >= parseInt(productStore.search)
    );
  }
  filteredList.value = tempList;
};

watch(() => productStore.searchResult.data, updateFilteredList, { immediate: true });
watch(() => productStore.search, updateFilteredList);

const headers = ref({
  number: {
    dataName: 'itemNo',
    translation: productStore.translations?.tableItemNo,
    isActive: false,
    sortNumber: true,
    Descending: false,
  },
  name: {
    dataName: 'displayName',
    translation: productStore.translations?.tableName,
    isActive: false,
    sortNumber: false,
    Descending: false,
  },
  family: {
    dataName: 'productFamiliesAsString',
    translation: productStore.translations?.tableProductFamily,
    isActive: false,
    sortNumber: false,
    Descending: false,
  },
  serialstart: {
    dataName: 'serialNumberStart',
    translation: productStore.translations?.tableSerialNumberStart,
    isActive: true,
    sortNumber: true,
    Descending: true,
  },
  serialstop: {
    dataName: 'serialNumberStop',
    translation: productStore.translations?.tableSerialNumberStop,
    isActive: false,
    sortNumber: true,
    Descending: false,
  },
  language: {
    dataName: 'language',
    translation: productStore.translations?.tableLanguage,
    isActive: false,
    sortNumber: false,
    Descending: false,
  },
  category: {
    dataName: 'category',
    translation: productStore.translations?.tableCategory,
    isActive: false,
    sortNumber: false,
    Descending: false,
  },
  programversion: {
    dataName: 'programVersion',
    translation: productStore.translations?.tableProgramVersion,
    isActive: false,
    sortNumber: false,
    Descending: false,
  },
});

const filteredHeaders = computed(() => {
  const result = { ...headers.value };
  if (productStore.selectedProduct !== 'E-Services') {
    delete result.programversion;
  }
  return Object.values(result);
});

const sortColumn = (header) => {
  const column = header.dataName;
  for (const th in headers.value) {
    headers.value[th].isActive = false;
    if (headers.value[th].dataName !== column) {
      headers.value[th].Descending = false;
    }
  }

  header.isActive = true;
  header.Descending = !header.Descending;

  filteredList.value = [...filteredList.value].sort((a, b) => {
    if (header.sortNumber) {
      return header.Descending ? b[column] - a[column] : a[column] - b[column];
    } else {
      const fa = a[column] ? a[column].toLowerCase() : '';
      const fb = b[column] ? b[column].toLowerCase() : '';
      if (header.Descending) {
        return fb < fa ? -1 : fb > fa ? 1 : 0;
      } else {
        return fa < fb ? -1 : fa > fb ? 1 : 0;
      }
    }
  });
};

const trackClick = (item) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "interaction",
    interaction_type: "product_search",
    document_type: item.category,
    document_language: item.language,
    document_name: item.displayName,
    market_language: document.getElementsByName("language")[0].value,
    product_family: item.ProductFamiliesAsString
  });
};
</script>